import { render } from "./InvestorsView.vue?vue&type=template&id=6061774c&scoped=true"
import script from "./InvestorsView.vue?vue&type=script&lang=js"
export * from "./InvestorsView.vue?vue&type=script&lang=js"

import "./InvestorsView.vue?vue&type=style&index=0&id=6061774c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061774c"]])

export default __exports__